/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespCollectionsModules_searchBrowse$ref = any;
type SbRespCollectionsModules_user$ref = any;
type SbRespCollectionsModules_viewer$ref = any;
type SbRespComponents_shippingFilters$ref = any;
type SbSharedHead_searchBrowse$ref = any;
type SbSharedRefetchContainer_regionalInfo$ref = any;
type SbSharedRefetchContainer_searchBrowse$ref = any;
type SbSharedRefetchContainer_shippingFilters$ref = any;
type SbSharedTrackingContainer_searchBrowse$ref = any;
type SbSharedTrackingContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespCollectionsLayout_viewer$ref: FragmentReference;
export type SbRespCollectionsLayout_viewer = {|
  +searchBrowse?: ?{|
    +$fragmentRefs: SbSharedRefetchContainer_searchBrowse$ref & SbRespCollectionsModules_searchBrowse$ref & SbSharedHead_searchBrowse$ref & SbSharedTrackingContainer_searchBrowse$ref
  |},
  +user?: ?{|
    +$fragmentRefs: SbSharedTrackingContainer_user$ref & SbRespCollectionsModules_user$ref
  |},
  +regionalInfo?: ?$ReadOnlyArray<?{|
    +$fragmentRefs: SbSharedRefetchContainer_regionalInfo$ref
  |}>,
  +shippingFilters?: ?$ReadOnlyArray<?{|
    +$fragmentRefs: SbSharedRefetchContainer_shippingFilters$ref & SbRespComponents_shippingFilters$ref
  |}>,
  +$fragmentRefs: SbRespCollectionsModules_viewer$ref,
  +$refType: SbRespCollectionsLayout_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode",
  "type": "String"
},
v1 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef",
  "type": "String"
};
return {
  "kind": "Fragment",
  "name": "SbRespCollectionsLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchSb",
      "type": "Boolean",
      "defaultValue": true
    },
    {
      "kind": "LocalArgument",
      "name": "hasPersonalizedFilter",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": "0"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "page",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "eligibleAbTest",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespCollectionsModules_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasPersonalizedFilter",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_regionalInfo",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shippingFilters",
          "storageKey": null,
          "args": [
            (v1/*: any*/),
            (v0/*: any*/)
          ],
          "concreteType": "ShippingFilterType",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_shippingFilters",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_shippingFilters",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedTrackingContainer_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespCollectionsModules_user",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchSb",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "searchBrowse",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "eligibleAbTest",
              "variableName": "eligibleAbTest",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first",
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "localeOrigin",
              "variableName": "localeOrigin",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "page",
              "variableName": "page",
              "type": "Int"
            },
            (v1/*: any*/)
          ],
          "concreteType": "SearchBrowseQueryConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_searchBrowse",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespCollectionsModules_searchBrowse",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbSharedHead_searchBrowse",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbSharedTrackingContainer_searchBrowse",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '6a847383c13ddd9d5d2ac9a175d97932';
module.exports = node;
